import { useEffect } from 'react';

const SEOHead = ({ 
  title = "Sidharth Sudhir - Software Engineer & UCLA Math/CS Student",
  description = "Sidharth Sudhir is a senior at UCLA studying Math/CS with software engineering experience at BlackRock, Siemens, and Open.Money. Passionate about AI, web development, and building innovative applications.",
  keywords = "Sidharth Sudhir, Software Engineer, UCLA, Math CS, BlackRock, Siemens, AI Developer, Web Development, Full Stack, React, JavaScript, Python, Machine Learning, Los Angeles, Software Engineering Intern",
  url = "https://sidharth.fyi/",
  image = "https://sidharth.fyi/logo512.png"
}) => {
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update or create meta tags
    const updateMetaTag = (name, content, property = false) => {
      const attribute = property ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attribute, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Basic meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('author', 'Sidharth Sudhir');

    // Open Graph tags
    updateMetaTag('og:type', 'website', true);
    updateMetaTag('og:url', url, true);
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', image, true);
    updateMetaTag('og:site_name', 'Sidharth Sudhir', true);

    // Twitter tags
    updateMetaTag('twitter:card', 'summary_large_image', true);
    updateMetaTag('twitter:url', url, true);
    updateMetaTag('twitter:title', title, true);
    updateMetaTag('twitter:description', description, true);
    updateMetaTag('twitter:image', image, true);

    // Update canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    // Update structured data
    let structuredDataScript = document.querySelector('#structured-data');
    if (!structuredDataScript) {
      structuredDataScript = document.createElement('script');
      structuredDataScript.id = 'structured-data';
      structuredDataScript.type = 'application/ld+json';
      document.head.appendChild(structuredDataScript);
    }
    
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Person",
      "name": "Sidharth Sudhir",
      "url": "https://sidharth.fyi",
      "image": "https://sidharth.fyi/logo512.png",
      "jobTitle": "Software Engineer",
      "worksFor": {
        "@type": "EducationalOrganization",
        "name": "UCLA"
      },
      "alumniOf": {
        "@type": "EducationalOrganization", 
        "name": "University of California, Los Angeles"
      },
      "knowsAbout": ["Software Engineering", "Mathematics", "Computer Science", "AI", "Web Development", "Full Stack Development", "React", "JavaScript", "Python"],
      "sameAs": [
        "https://github.com/sidharthsudhir",
        "https://linkedin.com/in/sidharthsudhir"
      ],
      "description": description
    };
    
    structuredDataScript.textContent = JSON.stringify(structuredData);
  }, [title, description, keywords, url, image]);

  return null; // This component doesn't render anything visible
};

export default SEOHead;
